<template>
  <MobileHeader :label="$t('nav.dashboard')" />
  <DashboardLayout>
    <template #main>
      <ConditionOverview
        :organisationId="organisationId"
        :shaftId="shaftId"
      />
      <MemberConditions
        :organisationId="organisationId"
        :shaftId="shaftId"
      />
      <Graphs
        :organisationId="organisationId"
        :shaftId="shaftId"
      />
    </template>
    <template #sidebar>
      <DashboardWarnings
        :organisationId="organisationId"
        :shaftId="shaftId"
        @see-all-warnings="handleSeeAllWarnings"
      />
      <DashboardInspections
        v-if="!warningSeeAll"
        inspectionPath="shaftInspection"
        :inspectionsEndpoint="inspectionsEndpoint"
      />
    </template>
  </DashboardLayout>
</template>

<script setup>
import { ref, computed } from 'vue';

import ConditionOverview from '@/components/shafts/dashboard/condition_overview.vue';
import DashboardInspections from '@/components/dashboard/dashboard_inspections.vue';
import DashboardLayout from '@/components/dashboard/dashboard_layout.vue';
import DashboardWarnings from '@/components/shafts/dashboard/dashboard_warnings.vue';
import Graphs from '@/components/shafts/dashboard/graphs.vue';
import MemberConditions from '@/components/shafts/dashboard/member_conditions.vue';
import MobileHeader from '@/components/generic/mobile_header.vue';

const props = defineProps({
  organisationId: { type: String, required: true },
  shaftId: { type: String, required: true },
});

const warningSeeAll = ref(false);

const BASE_URL = computed(() => `/organisations/${props.organisationId}/shafts/${props.shaftId}/dashboard`);
const inspectionsEndpoint = computed(() => `${BASE_URL.value}/inspections`);

/**
 * Emitted from dashboard warnings
 *  shows or hides sidebar panels
 */
const handleSeeAllWarnings = (seeAllState) => {
  warningSeeAll.value = seeAllState;
};
</script>
